import React, { Component } from "react";
import { Button, FormGroup, FormControl, ControlLabel, DropdownButton, MenuItem } from "react-bootstrap";
import uniqueId                 from 'lodash/uniqueId';
import Sortable                 from 'react-sortablejs';
import { FontAwesomeIcon }      from '@fortawesome/react-fontawesome'
import { faCoffee }             from '@fortawesome/free-solid-svg-icons'
import SortableDayViewBlockList from "../../components/sortable/SortableDayViewBlockList";
import LoaderButton             from "../../components/LoaderButton";
import { ExerciseFreeFormId }   from "../../utils/StaticIds";

export default class CreateDayView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDayView:   this.props.showDayView,
            programBlock: this.props.program_block,
            weekId      : this.props.week_id,
            weekCurrent : this.props.week_current,
            dayId       : this.props.day_id,
            dayCurrent  : this.props.day_current,
            daysIdOrder : this.props.days_id_order,
        }
    }

    componentDidMount() {
        var exercise_ids = this.getExerciseIdsFromNotes();

        this.setState({
            exerciseIdsWithNotes: exercise_ids
        });
    }

    componentWillReceiveProps( nextProps) {
        var exercise_ids = this.getExerciseIdsFromNotes();

        this.setState({
            showDayView : nextProps.showDayView,
            programBlock: nextProps.program_block,
            weekId      : nextProps.week_id,
            weekCurrent : nextProps.week_current,
            dayId       : nextProps.day_id,
            dayCurrent  : nextProps.day_current,
            daysIdOrder : nextProps.days_id_order,
            exerciseIdsWithNotes: exercise_ids
        })
    }

    getExerciseIdsFromNotes () {
            var exercise_notes = this.props.exerciseNotes;

            var exercise_lgth  = 0;
            var notes_arr      = [];
            if(exercise_notes != undefined && exercise_notes != "") exercise_lgth  = exercise_notes.length;

            if(exercise_lgth > 0) {
                for(var e=0; e < exercise_lgth; e++) {
                    var tmp_exercise_id = exercise_notes[e].exercise_id;
                    var notes = exercise_notes[e].notes;

                    notes_arr.push(tmp_exercise_id)
                }
            }

            return notes_arr;
    }

    openAddNewExerciseModal = (index) => {
        this.props.openAddNewExerciseModal(index);
    }

    getSingleBlockRow(week_id, day_id, block_ids_arr, block_id, index, value, name) {
        var block;
        var addExerciseRow = <div className="addExerciseContainer">
                                <div className="addExerciseDottedContainer"
                                     onClick={() => this.openAddNewExerciseModal(index)}
                                     key={uniqueId()}>
                                       <span className="addExerciseRow">
                                              + Add Exercise
                                       </span>
                                 </div>
                            </div>

        //// If Exercise is a Free Form Id, do not show the "+ Add Exercise" row ////
        if(value.exercise != undefined)
            if(value.exercise[index] != undefined){
                 if(value.exercise[index].id == ExerciseFreeFormId) {
                        addExerciseRow = null;
                    }
            }


        if(block_id != undefined) {

            block = <SortableDayViewBlockList
                        key                     = {uniqueId()}
                        index                   = {index}
                        name                    = {name}
                        week_id                 = {week_id}
                        day_id                  = {day_id}
                        block_id                = {block_id}
                        block_name              = {name}
                        value                   = {value}
                        block_ids               = {block_ids_arr}
                        //showExerciseDetailRow   = {"this.state.showExerciseDetailRow"}
                        addExerciseRow          = {addExerciseRow}
                        handleSaveBlock         = {this.props.handleSaveBlock}
                        getProgramDOMTree       = {this.props.getProgramDOMTree}
                        handleDeleteExercise    = {this.props.handleDeleteExercise}
                        handleChangeBlockName   = {this.props.handleChangeBlockName}
                        showDayModalSimple      = {this.props.showDayModalSimple}
                        sortBlocksOnDayView     = {this.props.sortBlocksOnDayView}
                        handleDuplicateBlock    = {this.props.handleDuplicateBlock}
                        handleDeleteBlock       = {this.props.handleDeleteBlock}
                        exerciseIdsWithNotes    = {this.state.exerciseIdsWithNotes}
                   />
           }

           return block;
    }

    getAllBlockIdsOnDayView (program_block) {
        var tmp_arr = [];
        var blocksList = Object.keys(program_block).map( index => {
                    var value     = program_block[index];
                    var block_id  = value.block_id;
                    tmp_arr.push(block_id)
        })

        return tmp_arr;
    }

    changeDayViewSingleDay = (day_id, day_current) => {
        this.props.changeDayViewSingleDay(day_id, day_current);
    }

    renderDayListTabs = (week_current, day_current, days_id_order) => {
        //console.log("*** DAY VIEW - renderDayListTabs ***");
        //const curr_day = this.state.day_current;
        //var days       = this.state.days_id_order;
        var day_tabs;
        var week_id       = this.state.weekId;

        if(days_id_order != null) {
            var menu_items;
            var that = this;

            menu_items = Object.keys(days_id_order).map(function (key) {
                            var day_num = parseInt(key) + 1;
                            var day_id = days_id_order[key].uid;

                            return (
                                    <MenuItem key={uniqueId()}
                                              style = {{paddingTop:"6px", fontSize:"20px"}}
                                              eventKey={day_num}
                                              onClick={() => that.changeDayViewSingleDay(day_id, day_num)}>
                                        Day {day_num}
                                    </MenuItem>
                                    )
            })
            var total_days = Object.keys(days_id_order).length;

            day_tabs =  Object.keys(days_id_order).map(function (key) {
                            var day_num = parseInt(key) + 1;
                            var day_id = days_id_order[key].uid;
                            var day;
                            var weight       = "normal";
                            var borderBottom = "0px";
                            var activeDay;
                            // "add_new_day_ctr === day_current" shows below header if a new day is added
                            //var add_new_day_ctr = total_days + 1;
                            // || (day_num === total_days && add_new_day_ctr === day_current)

                            // REMOVE "{}" CONDITION IF WE WANT TO DISPLAY ALL DAYS
                            if (day_current === day_num) {
                                    weight    = "bold";
                                    return (
                                        <span key={uniqueId()} className="dayViewDropdownDayButtons">
                                            <span style = {{color:"#666", fontWeight: weight, fontSize:"28px"}}>
                                                Week  {week_current} :
                                                        <span style={{color:"#000"}}>{ " DAY " + day_num} </span>

                                                        <DropdownButton
                                                              bsSize    = "large"
                                                              title     = ""
                                                              id        = "dropdown-size-large"
                                                              className = "pullRight dropdownSelectDayCaret"
                                                              style     = {{color:"#fff", backgroundColor: "transparent",  overflowY:"hidden", zIndex:200}}
                                                        >
                                                            { menu_items }
                                                        </DropdownButton>
                                            </span>
                                            { /*<span className="dayContainer">
                                                <span className="addNewDayLink" onClick={() => this.createProgramDay()}>+ Day</span>
                                            </span> */ }
                                            { activeDay }

                                            <div className="btn-group pull-right" role="group" style={{ position:"absolute", zIndex:1000, right:"0px",  border:"0px solid black"}}>
                                                <button type="button"
                                                        className="btn btn-default"
                                                        onClick={() => this.props.createProgramDay(week_id, total_days+1)}
                                                >
                                                    Add Day
                                                </button>
                                                <button type="button"
                                                        className="btn btn-default"
                                                        onClick={() => this.props.deleteProgramDay()}
                                                >
                                                    Delete Day
                                                </button>

                                                <button type="button"
                                                        className="btn btn-default"
                                                        onClick={() => this.props.duplicateProgramDay()}
                                                >
                                                    Duplicate Day
                                                </button>
                                            </div>
                                            { /*}<span className = "dropdownDayContaine pull-right">
                                                            <DropdownButton
                                                              bsSize    = "large"
                                                              title     = ""
                                                              id        = "dropdown-size-large"
                                                              className = "dropdownDayCaret"
                                                              style     = {{backgroundColor: "#999"}}
                                                              onSelect={(eventKey) => this.props.handleDayDropdownChange(eventKey, day_num, day_id)}
                                                            >
                                                                    <MenuItem eventKey="2">Duplicate Day</MenuItem>
                                                                    <MenuItem divider />
                                                                    <MenuItem eventKey="3">Delete Day</MenuItem>
                                                            </DropdownButton>
                                                        </span>*/ }
                                        </span>
                                    )
                            }
                        }, this)
            }

        return day_tabs;
    }

    render () {
        var program_block = this.state.programBlock;
        var week_id       = this.state.weekId;
        var week_current  = this.state.weekCurrent;
        var day_id        = this.state.dayId
        var day_current   = this.state.dayCurrent;
        var days_id_order = this.state.daysIdOrder;
        var show_day_view = this.state.showDayView;
        var blocksList;
        var block_ids_arr = this.getAllBlockIdsOnDayView(program_block);

        blocksList = Object.keys(program_block).map( index => {
                    var value      = program_block[index];
                    var block_name = value.block_name;
                    var block_id   = value.block_id;


                    ////  GET BLOCK NAME, if none, increment Block #  ////
                    if(block_name != undefined) {

                            var res     = block_name.toString().split(" ");
                            var res1    = res[1];
                            var isBlock = res[0];
                            var int     = parseInt(res1);

                            //// If the block title is "Block " + number, increment the block #  ////
                            ////  OR if there is no block name at all, add an incremented block
                            if(isBlock === "Block" && int != "NaN" || (isBlock == "" && res1 == undefined))
                                block_name = "Block " + (parseInt(index)+1);
                    }

                    { return this.getSingleBlockRow(week_id, day_id, block_ids_arr, block_id, index, value, block_name) }
        })

        return (
            <div style={{display: show_day_view}} >
                        { /* WEEKS TAB
                            <div>
                                <div className="weekContainer">
                                    { this.renderWeekListTabs() }
                                    &nbsp; &nbsp; <span className="addNewWeekLink" onClick={() => this.addNewWeekFromDayView()}>+ Week</span>
                                </div>
                            </div>*/ }
                        { this.renderDayListTabs (week_current, day_current, days_id_order) }
                        <div className="dayMainContaine">
                                { blocksList }
                        </div>
                        <span className="pull-left addNewBlockFooter">
                              <span className="blockFooterButtonNewBlock"
                                    onClick={this.props.handleAddBlock} >
                                   + Add New Block
                              </span>
                              <span className="blockFooterButtonSaveBlock"
                                    onClick={this.props.handleAddBlockTemplate}>
                                  + Add Block Template
                              </span>
                              <span className = "blockFooterButtonFreeFormBlock"
                                     onClick={this.props.handleAddFreeFormBlock} >
                                   + Add FreeForm Block
                              </span>
                        </span>
                <br/><br/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/CreateDayView.js